// extracted by mini-css-extract-plugin
export default {"employee-header":"Header_employee-header__j59t5","employee-header-item":"Header_employee-header-item__Xiupb"};